app.controller("RegisterController", ["$scope", "AuthService", "InfoModal",
    function ($scope, AuthService, InfoModal) {
        $scope.success = false;
        $scope.error = false;
        $scope.pn = "";
        $scope.search = function () {
            AuthService.emis($scope.emis).then(function (user) {
                // console.dir(user);
                if (!user.user) {
                    InfoModal.show({message: "მომხმარებელი უკვე გააქტიურებულია, ან ასეთი მომხმარებელი არ მოიძებნა", title: "ყურადღება"});
                }
                $scope.pn = user.user._id;
                $scope.email = user.user.email;
            })
        };

        $scope.submit = function () {
            if ($scope.pn == "") {
                return InfoModal.show({message: "პირადი ნომერი არ მოიძებნა", title: "ყურადღება"});
            }

            if ($scope.email) {
                AuthService.restoreUser({email: $scope.email, personalNumber: $scope.pn}).then(function (data) {
                    $scope.success = true;
                    $scope.error = false;
                }).catch(function (err) {
                    console.error(err);
                    $scope.success = false;
                    $scope.error = true;
                })
            } else {
                return InfoModal.show({
                    message: "შეიყვანეთ მეილი, რომელზეც მიიღებთ დეტალურ ინსტრუქციას",
                    title: "შეცდომა"
                });
            }
        }
    }
]);